import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["items", "stepShadow", "lastStepCheck", "className"];
var __jsx = React.createElement;
import { CheckOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import DixuText from "../DixuText/DixuText";
import DixuTitle from "../DixuTitle/DixuTitle";
import React from 'react';
const DixuStepList = _ref => {
  let {
      items,
      stepShadow,
      lastStepCheck,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-step-list', className);
  const lastIndex = items.length - 1;
  const steps = items.map((item, index) => {
    const {
      name,
      value,
      description
    } = item;
    const icon = (() => {
      const iconClasses = classNames('dixu-step-list__step-icon', 'bg-1-6', {
        'dixu-step-list__step-icon--check': lastStepCheck && index === lastIndex,
        [`box-shadow-${stepShadow}`]: stepShadow
      });
      if (lastStepCheck && index === lastIndex) {
        return /*#__PURE__*/React.createElement("span", {
          className: iconClasses
        }, /*#__PURE__*/React.createElement(DixuText, {
          color: "2-6",
          weight: "bold"
        }, /*#__PURE__*/React.createElement(CheckOutlined, null)));
      }
      return /*#__PURE__*/React.createElement("span", {
        className: iconClasses
      }, /*#__PURE__*/React.createElement(DixuText, {
        color: "2-1",
        weight: "bold"
      }, index + 1));
    })();
    return /*#__PURE__*/React.createElement("li", {
      key: name,
      className: "dixu-step-list__step"
    }, /*#__PURE__*/React.createElement("span", {
      className: "dixu-step-list__step-main-info"
    }, /*#__PURE__*/React.createElement("span", {
      className: "dixu-step-list__step-icon-wrapper",
      "aria-hidden": "true"
    }, icon), /*#__PURE__*/React.createElement("span", {
      className: "dixu-step-list__step-content"
    }, /*#__PURE__*/React.createElement(DixuTitle, {
      level: "3",
      color: "2-8",
      weight: "bold",
      margin: "0",
      noSemantics: true
    }, name), value && /*#__PURE__*/React.createElement(DixuText, {
      font: "4",
      color: "2-6",
      block: true,
      responsive: true
    }, value))), /*#__PURE__*/React.createElement("span", {
      className: "dixu-step-list__step-description"
    }, /*#__PURE__*/React.createElement(DixuText, {
      font: "3",
      color: "2-6"
    }, description)));
  });
  return /*#__PURE__*/React.createElement("ol", _extends({
    className: classes
  }, rest), steps);
};
DixuStepList.defaultProps = {
  stepShadow: undefined,
  lastStepCheck: false
};
export default DixuStepList;